import React from 'react';
import {observer} from "mobx-react";

import {PlayByPlayWidgetAsync} from "../../../../play-by-play-widget/components/play-by-play-widget.async";
import {PLAY_BY_PLAY} from "../../../../play-by-play-widget/play-by-play-widget.consts";
import {ACTION_TYPES} from "../../../../../core/consts";
import {MATCH_EVENTS} from "../../../match-widget.consts";

export const MatchEventsModulePlayByPlay = observer(({controller, gameId, location}) => {
  const {state} = controller;
  const {isLive, shouldRenderPreviewPlayByPlay} = state;

  const playByPlayProps = {
    gameId,
    location,
    source: PLAY_BY_PLAY.ANALYTICS.SOURCE.tab,
    isPreviewMode: true,
    isLive,
    onShowAllClick: () => controller.action(ACTION_TYPES.tabChange, {index: MATCH_EVENTS.TABS.commentary.index})
  }

  return shouldRenderPreviewPlayByPlay ? <PlayByPlayWidgetAsync {...playByPlayProps}/> : null
});
